module.exports = __webpack_public_path__ + "img/compare-full.9f955c2f.svg";